import React from "react";

import MovewareJobPicker from "./moveware/MovewareJobPicker";
import { dockActivityTypeFor } from "./moveware/movewareActivityOptions";
import useAuth from "src/hooks/useAuth";

export default function IntegrationCounterpartField({
  project,
  linkableType,
  linkableId,
  date,
  embedded = false,
  onLinked,
  onLinkStateChange,
  error,
}) {
  const { user } = useAuth();
  const providers = user?.company?.enabledIntegrationProviders || [];

  if (!linkableId || !project?.id) return null;
  // Provider-specific picker only. Persist stays generic (lookup + link).
  // A NetSuite adapter would add a branch here, not a netsuite_id column.
  if (providers.includes("moveware")) {
    return (
      <MovewareJobPicker
        project={project}
        linkableType={linkableType}
        linkableId={linkableId}
        date={date}
        activityType={dockActivityTypeFor(linkableType)}
        embedded={embedded}
        onLinked={onLinked}
        onLinkStateChange={onLinkStateChange}
        error={error}
      />
    );
  }

  return null;
}
